export interface AppSpecs {
  'specs.funnel.TemplatesGalleryUseReactDomHydrate': 'true' | 'false';
  'specs.funnel.templatePageHideEditButton': 'true' | 'false';
}

export const defaultAppSpecs: AppSpecs = {
  'specs.funnel.TemplatesGalleryUseReactDomHydrate': 'false',
  'specs.funnel.templatePageHideEditButton': 'false',
};
